module.exports = __webpack_public_path__ + "media/images/address-f714ef370b5a3bea44d7d1c743dfe8df.svg";